import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/ico_complection.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("결제 완료")
const _hoisted_3 = { class: "order_completion" }
const _hoisted_4 = { class: "order_completion_area" }
const _hoisted_5 = { class: "box_completion" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "img_area" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("strong", { class: "completion_tit" }, "선물 완료", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "desc" }, [
  /*#__PURE__*/_createTextVNode("보낸 선물은 받는 사람에게 "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("MMS로 전송됩니다.")
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("strong", { class: "completion_tit" }, "구매 완료", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "desc" }, [
  /*#__PURE__*/_createTextVNode("구매한 선물은 선물함 > 보유선물에서 "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("확인할 수 있습니다.")
], -1)
const _hoisted_11 = { class: "btn_area_wrap" }
const _hoisted_12 = { class: "btn_area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")

  return (_openBlock(), _createBlock("div", {
    id: "wrap",
    class: ["wrap", {app_view: _ctx.isApp}]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_header_component, null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          (_ctx.isPresentOrder)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_7,
                _hoisted_8
              ], 64))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _hoisted_9,
                _hoisted_10
              ], 64))
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          (_ctx.isPresentOrder)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.moveToMain && _ctx.moveToMain(...args))),
                  type: "button",
                  class: "btn btn_default"
                }, "계속 선물하기"),
                _createVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.moveToMyOrder && _ctx.moveToMyOrder(...args))),
                  type: "button",
                  class: "btn btn_full"
                }, "구매내역 보기")
              ], 64))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _createVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.moveToMain && _ctx.moveToMain(...args))),
                  type: "button",
                  class: "btn btn_default"
                }, "계속 구매하기"),
                _createVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.moveToMyTicket && _ctx.moveToMyTicket(...args))),
                  type: "button",
                  class: "btn btn_full"
                }, "교환권 보기")
              ], 64))
        ])
      ])
    ])
  ], 2))
}